import styled from "styled-components";

export const StyledTitle = styled.h1`
  font-size: 36px;
  margin: 20px 0 50px 0;
  text-align: center;
  color: ${(props) => props.theme.colors.primary.main};
`;
